import type { StateWithSinatra } from '../types';

export const selectUser = (state: StateWithSinatra) => state.sinatra.user;
